export const LOCALE_COOKIE_KEY = 'site_i18n_current_locale'
export const LOCALE_PREFERENCE_MODE_KEY = 'site_i18n_locale_preference_mode'
export const LOCALE_TEMPLATE_KEY = 'site_i18n_locale_template_key'

export const LOCALE_PREFERENCE_MODES = {
  AUTO: 'auto',
  MANUAL: 'manual',
}

